import CustomerLevelRequirementSummaryList from "../../components/customer/CustomerLevelRequirementSummaryList";

const CustomerLevelRequirementSummariesPage = () => {

    return <CustomerLevelRequirementSummaryList/>
}

export default CustomerLevelRequirementSummariesPage;
